var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var cio_datamodel = require("cio-datamodel");

var ShapeWrapperInteractionView = require("./../../shapeWrapperViewer/shapeWrapperInteractionView.js");

var DocumentationInteractionView = function (editorView, interactionModel, parentGroup, layers) {
    ShapeWrapperInteractionView.apply(this, arguments);
};
lib_core.inherit(DocumentationInteractionView,  ShapeWrapperInteractionView);

module.exports = DocumentationInteractionView;

DocumentationInteractionView.prototype.getLayers = function () {
    //Don't like checking for footprintlayers.TOP and also for 0...
    if(this.data.layerIndex.contains(0) &&
        (this.editorModel.visibleLayers.contains(0) || this.editorModel.visibleLayers.contains(cio_datamodel.FootprintLayers.TOP))) {
        console.assert(this.layers.documentationTop && this.layers.documentationTopControl, "Missing layers");

        return {
            draw: this.layers.documentationTop,
            control: this.layers.documentationTopControl,
            interaction: this.layers.interaction,
            interactionControl: this.layers.interactionControl
        };
    }
    else if(this.data.layerIndex.contains(1) &&
        (this.editorModel.visibleLayers.contains(1) || this.editorModel.visibleLayers.contains(cio_datamodel.FootprintLayers.BOTTOM))){
        console.assert(this.layers.documentationBottom && this.layers.documentationBottomControl, "Missing layers");

        return {
            draw: this.layers.documentationBottom,
            control: this.layers.documentationBottomControl,
            interaction: this.layers.interaction,
            interactionControl: this.layers.interactionControl
        };
    }
}